import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import DateFormatter from "../../DateFormatter";
import { dateFine } from "../../../util/Utilities";
import UserHavePermission from "../../../util/UserHavePermission";
import SystemInfo from "../../../util/SystemInfo";

const ZoneBiColumns = [
    {
        Label: TableCheck,
        Component: TableCheck
    },
    {
        Label: () => 'id',
        accessor: 'id',
        sortField: 'id'
    },
    {
        Label: () => 'Nombre de Zona',
        sortField: 'name',
        Component: ({ value }) => value?.name || '--'
    },
    {
        Label: () => 'Fecha de Creación',
        sortField: 'created_at',
        Component: ({ value }) => value?.createdAt || '--'
    },
    {
        Label: () => 'Acciones',
        Component: (props) => <ActionDropdown
            {...props}
            canUpdate={UserHavePermission(`${SystemInfo?.systemCode}-update-zones-bi`)}
            showDelete={UserHavePermission(`${SystemInfo?.systemCode}-delete-zones-bi`)}
        />
    }
];

export default ZoneBiColumns;
